import { render, staticRenderFns } from "./RecommendClinicComponent.vue?vue&type=template&id=cfae047a&scoped=true&"
import script from "./RecommendClinicComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendClinicComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendClinicComponent.vue?vue&type=style&index=0&id=cfae047a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfae047a",
  null
  
)

export default component.exports